module.exports = __webpack_public_path__ + "img/MotorWithoutVFD.47bf02da.png";